import * as React from 'react';

var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgBreathability = function SvgBreathability(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2E31",
    fillRule: "evenodd",
    d: "M20 38.5c10.217 0 18.5-8.283 18.5-18.5S30.217 1.5 20 1.5 1.5 9.783 1.5 20 9.783 38.5 20 38.5ZM40 20c0 11.046-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0s20 8.954 20 20Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2E31",
    fillRule: "evenodd",
    d: "M23.75 8a.75.75 0 0 1 .75.75V17a.75.75 0 0 1-1.5 0V8.75a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2E31",
    fillRule: "evenodd",
    d: "M23.22 8.22a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 1 1-1.06 1.06l-2.25-2.25a.75.75 0 0 1 0-1.06Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2E31",
    fillRule: "evenodd",
    d: "M24.28 8.22a.75.75 0 0 1 0 1.06l-2.25 2.25a.75.75 0 1 1-1.06-1.06l2.25-2.25a.75.75 0 0 1 1.06 0ZM16.25 8a.75.75 0 0 1 .75.75V17a.75.75 0 0 1-1.5 0V8.75a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2E31",
    fillRule: "evenodd",
    d: "M15.72 8.22a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 1 1-1.06 1.06l-2.25-2.25a.75.75 0 0 1 0-1.06Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2E31",
    fillRule: "evenodd",
    d: "M16.78 8.22a.75.75 0 0 1 0 1.06l-2.25 2.25a.75.75 0 1 1-1.06-1.06l2.25-2.25a.75.75 0 0 1 1.06 0ZM14.745 24.584a8.233 8.233 0 0 0-5.498 2.062.75.75 0 1 1-.993-1.124 9.733 9.733 0 0 1 6.498-2.438c1.104 0 2.36.458 3.592.95.252.1.506.203.761.307 1.048.425 2.128.865 3.258 1.188 1.395.4 2.799.603 4.184.377 1.371-.223 2.777-.874 4.173-2.27a.75.75 0 1 1 1.06 1.061c-1.604 1.605-3.292 2.413-4.992 2.69-1.684.274-3.327.018-4.838-.416-1.216-.348-2.39-.825-3.441-1.253-.247-.101-.488-.199-.72-.292-1.275-.508-2.268-.842-3.039-.842h-.005ZM14.745 20.084a8.233 8.233 0 0 0-5.498 2.062.75.75 0 1 1-.993-1.124 9.733 9.733 0 0 1 6.498-2.438c1.104 0 2.36.458 3.592.95.252.1.506.203.761.307 1.048.425 2.128.865 3.258 1.188 1.395.4 2.799.603 4.184.377 1.371-.223 2.777-.874 4.173-2.27a.75.75 0 1 1 1.06 1.061c-1.604 1.605-3.292 2.413-4.992 2.69-1.684.274-3.327.018-4.838-.416-1.216-.348-2.39-.825-3.441-1.253-.247-.101-.488-.199-.72-.292-1.275-.508-2.268-.842-3.039-.842h-.005ZM14.745 29.084a8.233 8.233 0 0 0-5.498 2.062.75.75 0 1 1-.993-1.124 9.733 9.733 0 0 1 6.498-2.438c1.104 0 2.36.458 3.592.95.252.1.506.203.761.307 1.048.425 2.128.865 3.258 1.188 1.395.4 2.799.603 4.184.377 1.371-.223 2.777-.874 4.173-2.27a.75.75 0 1 1 1.06 1.061c-1.604 1.605-3.292 2.413-4.992 2.69-1.684.274-3.327.018-4.838-.416-1.216-.348-2.39-.825-3.441-1.253-.247-.101-.488-.199-.72-.292-1.275-.508-2.268-.842-3.039-.842h-.005Z",
    clipRule: "evenodd"
  })));
};

export { SvgBreathability as default };
//# sourceMappingURL=breathability.svg.js.map
